<template>
    <div style="width: 1px; height: 1px; overflow: hidden;" id="pdf-content" v-if="plan">
        <div style="padding: 0 1.25cm">
            <div style="padding: 20px 16px;"">
                <span style="font-size: 28px; font-weight: normal">{{ $t('pdf.calculation-for-dental-treatment') }}</span>
                <br/>
                <span style="font-size: 12px;">{{ $t('pdf.created-at') }} {{ currentTime }}</span><br/>
            </div>

            <div v-for="(jaw, i) in ['upper','lower']" :key="jaw" style="margin-bottom: 20px;">
                <div style="padding: 6px 16px; background: #eee;">
                    <span style="font-size: 14px; font-weight: 600">{{ $t('plan_calculator.' + jaw) }}</span>
                    <pm-price style="font-size: 14px; font-weight: 600; float: right;" :currency="$store.state.currency" :value="plan.total[jaw]" />
                </div>
                <template v-if="Object.keys(plan.steps[jaw]).length > 0">
                    <table style="width: 100%;">
                        <tr v-for="(amount, stateId) in plan.steps[jaw]">
                            <td style="line-height: 1; vertical-align: center; border-bottom: 1px solid #eee; padding: 4px 16px;">
                                <span style="font-size: 12px; color: #000;">{{ $store.getters['smart/titleOfTreatment'](stateId, $store.state.language, true) }}</span>
                                <br/>
                                <span style="font-size: 11px; color: rgb(70, 73, 77);">
                                    {{ amount }} &times; <pm-price :value="$store.getters['smart/priceOfTreatment'](stateId, $store.state.currency)" hide-currency />
                                </span>
                            </td>
                            <td style="vertical-align: center; text-align: right; border-bottom: 1px solid #eee; padding: 4px 16px;">
                                <pm-price style="font-size: 13px; text-align: right; font-weight: normal!important;" :value="amount * $store.getters['smart/priceOfTreatment'](stateId, $store.state.currency)" :currency="$store.state.currency" />
                            </td>
                        </tr>
                    </table>
                </template>
            </div>

            <div style="padding: 8px 16px; background: #eee;">
                <span style="font-size: 17px; font-weight: 600">{{ $t("plan_calculator.total") }} </span>
                <span class="overview--title roboto f14">({{ $t('plan_calculator.upper').toLowerCase() }} + {{ $t('plan_calculator.lower').toLowerCase() }})</span>
                <pm-price style="font-size: 17px; font-weight: 600; float: right;" :currency="$store.state.currency" :value="plan.fullTotal" />
            </div>

            <div style="padding: 24px 16px 8px 16px; text-align: right;"">
                <span style="font-size: 10px;">Made with DentiCalc</span>
            </div>

            <div style="text-align: justify; padding: 8px 16px; font-size: 10px;"">
                <p v-html="$t('send_email.content_part_08')"></p>
                <p v-html="$t('send_email.content_part_09', { companyName: 'PlanMaster Fogászati Szoftver Kft.'})"></p>
                <p v-html="$options.filters.capitalize($t('send_email.content_part_10', { dentistName: $t('send_email.your-dentist'), companyName: 'PlanMaster Fogászati Szoftver Kft.'}))"></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        plan: {
            type: Object
        }
    },
    computed: {
        currentTime() {
            try {
                const t = new Date();
                return new Intl.DateTimeFormat([this.$store.state.language, 'en-US'],  { dateStyle: 'long'}).format(t);
            } catch(error) {
                console.log(event.toLocaleTimeString('ar-EG'));
            }
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
}
</script>
